"use client";

import React from "react";

//Type
import { ButtonIconProps } from "@/types";

//Style
import * as S from "./styles";

const ButtonIcon: React.FC<ButtonIconProps> = ({
  className,
  icon,
  onClick,
  hovercolor = "green",
  children,
  href,
}) => {
  return (
    <>
      {href ? (
        <S.LinkIcon
          target="blank"
          className={className}
          href={href}
          $hovercolor={hovercolor}
        >
          {icon}
          {children}
        </S.LinkIcon>
      ) : (
        <S.ButtonIcon
          className={className}
          onClick={onClick}
          $hovercolor={hovercolor}
        >
          {icon}
          {children}
        </S.ButtonIcon>
      )}
    </>
  );
};

export default ButtonIcon;
